import { defineStore } from 'pinia'
import type { TallyItem, FormData } from '../types/tally'
import { TallyService } from '../Service/TallyService'

interface Company {
  tallycompany_id: number
  company_name: string
}

interface Branch {
  ID: number
  Name: string
}

interface Type {
  Id: number
  Name: string
}

interface Visit {
  Id: string
  Name: string
}

interface TallyState {
  loading: boolean
  POSTloading: boolean
  companies: { name: string; value: string }[]
  branches: { name: string; value: string }[]
  tallyTypes: { name: string; value: number, EntityId: number }[]
  visits: { name: string; value: string }[]
  tallyItems: TallyItem[]
}

export const useTallyStore = defineStore('tally', {
  state: (): TallyState => ({
    loading: false,
    POSTloading: false,
    companies: [],
    branches: [],
    tallyTypes: [],
    visits: [],
    tallyItems: []
  }),

  actions: {
    async fetchCompanies(HospitalId, BranchId, IsAdmin) {
      debugger;
      try {
        this.loading = true
        const response = await TallyService.getCompanies(HospitalId, BranchId, IsAdmin) as Company[]

        this.companies = response["result"]
          .map((item) => {
            item.name = item.company_name;
            item.value = item.tallycompany_id;
            return item;
          });

      } catch (error) {
        console.error('Error fetching companies:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async fetchBranches(HospitalId) {
      debugger;
      try {
        this.loading = true
        const response = await TallyService.getBranches() as Branch[]
        this.branches = response["result"].filter((x) => x.OrganizationId == HospitalId)
          .map((item) => {
            item.name = item.Name;
            item.value = item.ID;
            return item;
          });

      } catch (error) {
        console.error('Error fetching branches:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async fetchTallyTypes() {
      try {
        this.loading = true

        this.tallyTypes = [
          {
            value: 1,
            name: "Purchase",
            EntityId: 3141,
          },
          {
            value: 2,
            name: "Sales",
            EntityId: 3142,
          },
          {
            value: 3,
            name: "Transfer Out",
            EntityId: 3143,
          },
          {
            value: 4,
            name: "Purchase Return",
            EntityId: 3144,
          },
          {
            value: 5,
            name: "Supplier Payment",
            EntityId: 3145,
          },
          {
            value: 6,
            name: "Closing Stock",
            EntityId: 3146,
          },
          {
            value: 7,
            name: "Opening Stock",
            EntityId: 3147,
          },
        ];

      } catch (error) {
        console.error('Error fetching branches:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async fetchVisits() {
      try {
        this.loading = true
        const response = await TallyService.getVisits() as Visit[]
        this.visits = response.map((item) => ({
          name: item.Name,
          value: item.Id
        }));
      } catch (error) {
        console.error('Error fetching visits:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async fetchTallyData(params: FormData) {
      debugger;
      try {
        this.loading = true
        let count = 0;
        const stockInIdMap = new Map<string, number>();
        let voucherNo = 1;
        const response = await TallyService.getTallyData(params) as TallyItem[]
        this.tallyItems = response["result"].map((item) => {
          count = count + 1;
          item.sno = count;

          // if (item.Particulars) {
          //   item.Particulars = item.Particulars.replace(/'/g, "''");
          // }
          // else {
          //   item.Particulars = 'Annai Trading';
          // }

          if (!stockInIdMap.has(item.StockInId)) {
            stockInIdMap.set(item.StockInId, voucherNo);
            voucherNo++;
          }
          item.VoucherNo = stockInIdMap.get(item.StockInId);

          return item;
        });
      } catch (error) {
        console.error('Error fetching tally data:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    // async fetchTallyData(params: FormData) {
    //   debugger;
    //   try {
    //     this.loading = true
    //     let count = 0;
    //     const response = await TallyService.getTallyData(params) as TallyItem[]
    //     this.tallyItems = response["result"].map((item) => {
    //       count = count + 1;
    //       item.sno = count;
    //       item.VoucherNo = count;
    //       return item;
    //     });
    //   } catch (error) {
    //     console.error('Error fetching tally data:', error)
    //     throw error
    //   } finally {
    //     this.loading = false
    //   }
    // },


    async postTallyData(tallyItems: TallyItem[]) {
      try {
        this.POSTloading = true;
        const response = await TallyService.postTallyData(tallyItems);
      } catch (error) {
        console.error('Error posting tally data:', error);
        throw error;
      } finally {
        this.POSTloading = false;
      }
    },
  }
})
